import { connect } from "react-redux"
import ConfirmAuthPage from "./ConfirmAuthPage"
import { submitRemoveBackupCodes } from "../api_actions"

const mapStateToProps = (state) => {
  const me = state.me || {}

  return {
    errors: me.errors,
    syncing: !!me.syncing,
    loginStep: me.loginStep
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (password: string, otpCode: string) =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      dispatch(submitRemoveBackupCodes(password, otpCode)),

    onNoPass: () => dispatch({ type: "REMOVE_BACKUP_CODES" })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAuthPage)
